import { useCallback, useEffect, useState } from "react";
import { VehiclesAPI } from "../api/vehicles";

export function useVehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setErr("");
    try {
      const data = await VehiclesAPI.list();
      setVehicles(data || []);
    } catch (e) {
      setErr(e.message || "Failed to load vehicles");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const createVehicle = useCallback(async (payload) => {
    await VehiclesAPI.create(payload);
    await reload();
  }, [reload]);

  const updateVehicleById = useCallback(async (id, payload) => {
    await VehiclesAPI.update(id, payload);
    await reload();
  }, [reload]);

  const deleteVehicleById = useCallback(async (id) => {
    await VehiclesAPI.remove(id);
    // Optimistic update
    setVehicles((prev) => prev.filter((v) => v.id !== id));
  }, []);

  return {
    vehicles,
    setVehicles,
    loading,
    err,
    reload,
    createVehicle,
    updateVehicleById,
    deleteVehicleById,
  };
}
